import { FreeSubscriptionItem } from "./FreeSubscriptionItem";
import { FreeSubscription } from "@/common/model/FreeSubscription";

type FreeSubscriptionListProps = {
  subscriptions: FreeSubscription[];
  onEdit: (subscription: FreeSubscription) => void;
  onEndNow: (subscription: FreeSubscription) => void;
  onDelete: (subscription: FreeSubscription) => void;
};

export function FreeSubscriptionList({
  subscriptions,
  onEdit,
  onEndNow,
  onDelete,
}: FreeSubscriptionListProps) {
  return (
    <div className="space-y-4">
      Total {subscriptions.length} free subscriptions
      {subscriptions.map((subscription) => (
        <FreeSubscriptionItem
          key={subscription.id}
          subscription={subscription}
          onEdit={onEdit}
          onEndNow={onEndNow}
          onDelete={onDelete}
        />
      ))}
      {subscriptions.length === 0 && (
        <div className="text-center py-8">
          No subscriptions found. Add a new subscription to get started.
        </div>
      )}
    </div>
  );
}
